import {
  SalesChannel,
  SalesChannelResponse,
} from '../../models/sales-channel.model';

export function mapSalesChannelResponseToModel(
  response: SalesChannelResponse,
): SalesChannel {
  return {
    code: response.channel_code,
    name: response.channel_name,
  };
}
